const RgAggregatorVersion = "testv";
export { RgAggregatorVersion };

//# sourceMappingURL=index193.js.map